"use client";

import React, { useEffect, useRef } from "react";
import { VerticalCategory } from "@/interface/types";
import { useInactivityPopup } from "@/hooks/useInactivityPopup";
import { useModalScrollLock } from "@/hooks/useModalScrollLock";
import PopupForm from "./PopupForm";

interface NewInactivityPopupProps {
  course?: string;
  courseId?: number;
  verticalName?: VerticalCategory;
  subCategory?: string;
  pageName?: string;
  delay?: number;
}

const NewInactivityPopup: React.FC<NewInactivityPopupProps> = ({
  pageName = "cma-visit",
  delay = 5000,
}) => {
  const { showPopup, hidePopup } = useInactivityPopup({
    delay,
    sessionStorageKey: `inactivity-popup-${pageName}`,
  });

  useModalScrollLock(showPopup, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showPopup) {
      return;
    }
    const checkSuccess = () => {
      const root = popupRef.current;
      if (!root) return;
    };
    checkSuccess();
    const observer = new MutationObserver(checkSuccess);
    if (popupRef.current) {
      observer.observe(popupRef.current, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["src"],
      });
    }
    return () => observer.disconnect();
  }, [showPopup]);

  const handleClose = () => {
    sessionStorage.removeItem(`inactivity-popup-${pageName}`);
    sessionStorage.removeItem("user-interacted-form");
    localStorage.removeItem(`inactivity-popup-${pageName}`);
    hidePopup();
  };

  return (
    <>
      {showPopup && (
        <div ref={popupRef}>
          <PopupForm handleClose={handleClose} pageName={pageName} />
        </div>
      )}
    </>
  );
};
export default NewInactivityPopup;
